import React from 'react';

function LogoIcon({
  height = '30px',
  color = '#9092aa',
  onClick,
}: {
  height?: string;
  color?: string;
  onClick?: () => void;
}) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='31.76'
      height={height}
      viewBox='0 0 31.76 30.058'
      onClick={onClick}
    >
      <g
        id='Group_49'
        data-name='Group 49'
        transform='translate(-233.896 -407.175)'
      >
        <g
          id='Path_5'
          data-name='Path 5'
          transform='translate(233.895 407.175)'
        >
          <path
            id='Path_9'
            data-name='Path 9'
            d='M263.686,432.137l-11.9-22.093a2.639,2.639,0,0,0-4.665,0l-4.506,8.363.782,1.339,4.89-9.078a1.319,1.319,0,0,1,2.332,0l11.9,22.093a1.352,1.352,0,0,1-.027,1.312,1.309,1.309,0,0,1-1.14.649h-9.3l.755,1.325h8.548a2.663,2.663,0,0,0,2.333-3.91Zm-26.135,2.584a1.309,1.309,0,0,1-1.14-.649,1.352,1.352,0,0,1-.026-1.312l3.883-7.2-.782-1.352-4.267,7.925a2.663,2.663,0,0,0,2.332,3.91h8.773l-.769-1.325Z'
            transform='translate(-233.569 -407.315)'
            fill={color}
          />
          <path
            id='Path_10'
            data-name='Path 10'
            d='M265.178,431.827l-11.9-22.093a3.97,3.97,0,0,0-7,0l-4.122,7.647.782,1.352.782,1.339,4.89-9.078a1.319,1.319,0,0,1,2.333,0l11.9,22.093a1.352,1.352,0,0,1-.027,1.312,1.309,1.309,0,0,1-1.14.649h-9.3l.755,1.325.769,1.325h7.779A3.985,3.985,0,0,0,265.178,431.827Zm-19.3,3.22h-8a1.309,1.309,0,0,1-1.14-.649,1.352,1.352,0,0,1-.027-1.312l3.883-7.2-.782-1.352-.782-1.352-4.652,8.641a3.981,3.981,0,0,0,3.5,5.871h9.542l-.769-1.325Z'
            transform='translate(-233.895 -407.64)'
            fill={color}
          />
        </g>
      </g>
    </svg>
  );
}

export default LogoIcon;
